export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3000';
export const TOKEN_KEY = 'Calmpi_bo_token';
export const apiRequest = async (path, options = {}) => {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(body.message || body.error?.message || 'Request failed');
  return body.data ?? body;
};
